import styled, { css } from 'styled-components/macro'

interface VolumeSliderProps {
  value: number
}

const gray = '#FFFFFF66'
const white = '#FFFFFF'
// TODO: TAKE THIS DESIGN SYSTEM COLOR WHEN IT'S AVAILABLE
// const gray = ({ theme }) => theme.wsc.palette.neutral['700']

//the background of the volume slider is a gradient that goes from white to gray
const rangInputBackgroundCss = css`
  background: ${(props: VolumeSliderProps) =>
    `linear-gradient(to right, ${white} 0%, ${white} ${Number(props.value) * 100}%, ${gray} ${
      Number(props.value) * 100
    }%, ${gray} 100%);`};
`

export const StyledControls = styled.div`
  display: flex;
  align-items: center;
`

export const StyledVolumeSlider = styled.input.attrs({ type: 'range' })`
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  ${rangInputBackgroundCss}
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
  height: 4px;
  outline: none;
  transition: background 0.15s ease-in-out;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--thumb-color, #e5ff00);
    cursor: pointer;
  }
`

export const StyledButtonIcon = styled.div`
  cursor: pointer;
  margin: 0 5px;
`
